import { render, staticRenderFns } from "./reminders.vue?vue&type=template&id=3559d2a2&scoped=true&"
import script from "./reminders.vue?vue&type=script&lang=js&"
export * from "./reminders.vue?vue&type=script&lang=js&"
import style0 from "./reminders.vue?vue&type=style&index=0&id=3559d2a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3559d2a2",
  null
  
)

export default component.exports